import { createRouter, createWebHistory } from 'vue-router'
import { showNotify } from 'vant';
import { bllLogin } from '@/bll/Api';

const routes = [
  {
    path: '/',
    name: 'index',
    meta: { title: 'index' },
    component: () => import('../views/Index.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: () => import('../views/Login.vue')
  },
  {
    path: '/deviceinfo',
    name: 'deviceinfo',
    meta: { title: '设备详情' },
    component: () => import('../views/DeviceInfo.vue'),
    props({ query }) {
      return { id: query.id,CenterID:query.CenterID,MaintainProjectName:query.MaintainProjectName } //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/spotcheck',
    name: 'spotcheck',
    meta: { title: '设备点检' },
    component: () => import('../views/SpotCheck.vue'),
    props({ query }) {
      return { id: query.id,CenterID:query.CenterID,PlanSheetID:query.PlanSheetID } //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    meta: { title: '设备保养' },
    component: () => import('../views/Maintenance.vue'),
    props({ query }) {
      return { id: query.id,CenterID:query.CenterID,MaintainProjectName:query.MaintainProjectName} //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/devicestop',
    name: 'devicestop',
    meta: { title: '设备停机原因' },
    component: () => import('../views/DeviceStop.vue'),
    props({ query }) {
      return {  id: query.id,CenterID:query.CenterID } //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/devicefault',
    name: 'devicefault',
    meta: { title: '故障上报' },
    component: () => import('../views/DeviceFault.vue'),
    props({ query }) {
      return { id: query.id } //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/devicerepair',
    name: 'devicerepair',
    meta: { title: '设备维修' },
    component: () => import('../views/DeviceRepair.vue'),
    props({ query }) {
      return { id: query.id,CenterID:query.CenterID, RepairTaskID:query.RepairTaskID,StatusBegin:query.StatusBegin,DevDescription:query.DevDescription} //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/dayworktaskadd',
    name: 'dayworktaskadd',
    meta: { title: '新增日常工作任务' },
    component: () => import('../views/DayWorkTaskAdd.vue'),
    props({ query }) {
      return { id: query.id,CenterID:query.CenterID,CenterName:query.CenterName,Txt:query.Txt,EmployeeID:query.EmployeeID,EmployeeName:query.EmployeeName} //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/dayworktaskdispatch',
    name: 'dayworktaskdispatch',
    meta: { title: '指派日常工作任务' },
    component: () => import('../views/DayWorkTaskDispatch.vue'),
    props({ query }) {
      return { id: query.id,CenterID:query.CenterID, XzWorkID:query.XzWorkID,XzWorkName:query.XzWorkName} //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/devicedispatch',
    name: 'DeviceDispatch',
    meta: { title: '指派设备维修任务' },
    component: () => import('../views/DeviceDispatch.vue'),
    props({ query }) {
      return { id: query.id,CenterID:query.CenterID, RepairTaskID:query.RepairTaskID} //用组件参数的形式把query传递给组件
    },
  },
  {
    path: '/main',
    name: 'main',
    meta: { isAuth: true, title: '正阳MES' },
    component: () => import('../views/Main.vue'),
    children: [
      {
        path: 'device',
        name: 'device',
        meta: { title: '设备' },
        component: () => import('../views/Device.vue'),
        props({ query }) {
          return { keystr: query.keystr } //用组件参数的形式把query传递给组件
        },
      },     
      {
        path: 'checklist',
        name: 'checklist',
        meta: { title: '点检' },
        component: () => import('../views/CheckList.vue'),
      },
      {
        path: 'maintenancelist',
        name: 'maintenancelist',
        meta: { title: '保养' },
        component: () => import('../views/MaintenanceList.vue'),
      },
      {
        path: 'repairlist',
        name: 'repairlist',
        meta: { title: '维修' },
        component: () => import('../views/RepairList.vue'),
      },
      {
        path: 'faultlist',
        name: 'faultlist',
        meta: { title: '故障' },
        component: () => import('../views/FaultList.vue'),
        props({ query }) {
          return { keystr: query.keystr } //用组件参数的形式把query传递给组件
        },
      },
      {
        path: 'dayworktasklist',
        name: 'dayworktasklist',
        meta: { title: '日常' },
        component: () => import('../views/DayWorkTaskList.vue'),
      },
      {
        path: 'myuserinfo',
        name: 'myuserinfo',
        meta: { title: '我的' },
        component: () => import('../views/MyUserInfo.vue'),
      },
      {
        path: 'rfidsearch',
        name: 'rfidsearch',
        meta: { title: 'RFID查询' },
        component: () => import('../views/RfidSearch.vue'),
      },
      {
        path: 'testview',
        name: 'testview',
        meta: { title: '测试' },
        component: () => import('../views/TestView.vue'),
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

//路由切换前事件
router.beforeEach((to, from, next) => {

  //判断登录 
  if (to.name != 'login') {
    //有TOKEN继续下去
    if (sessionStorage.getItem('Token')) {
      next();//路由继续下去
    } else {
      //没有token保存了用户密码的，自动重新登录
      if (localStorage.getItem("UserName") && localStorage.getItem("Pwd")) {
        var jsonObj = {
          UserName: localStorage.getItem("UserName"),
          Pwd: localStorage.getItem("Pwd")
        }

        bllLogin(jsonObj).then((res)=>{
          console.log('自动登录',res);
          if (res.Code == 0) {
            next();//路由继续下去
          } else {
            showNotify({ type: 'warning', message: res.Msg });
            setTimeout(() => {
              router.push('/login');
            }, 1000);
          }
        });
        
      } else {
        //没有保存用户密码的，手动登录
        showNotify({ type: 'warning', message: '你没有登录' });
        setTimeout(() => {
          router.push('/login');
        }, 1000);
      }
    }

  } else {
    next(); //路由继续下去
  }
})
//路由切换后事件
router.afterEach((to, from) => {
  document.title = to.meta.title
})

export default router
